






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  saveExpenseCategory,
  ExpenseCategory
} from "@/api/cost/expense-categories-api";
import { cloneDeep } from "lodash";
import { EXPENSE_CATEGORIES_READONLY } from "@/preferences";

@Component({ components: {} })
export default class ExpenseCategoryForm extends Vue {
  @Prop({ type: Object }) defaultValues?: ExpenseCategory;

  values: ExpenseCategory = {
    id: "",
    name: "",
    important: false
  };

  // 値を引き継ぐ
  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(values: ExpenseCategory) {
    if (!values) {
      return;
    }
    this.values = cloneDeep(values);
  }

  // APIへ保存する値を渡す
  public async submit() {
    await saveExpenseCategory(this.values);
    this.$emit("submit");
  }

  get isDisabledChangeName() {
    return EXPENSE_CATEGORIES_READONLY.includes(this.values.name);
  }
}
